import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'
import { HStack } from '../hstack'
import { Text } from '../text'

export type MessageBottomRow = {
    label: string
    value: string
}

export type MessageBottomProps = {
    message: string
    rows: MessageBottomRow[]
    className?: string
    testID?: string
}

export const MessageBottom: React.FC<MessageBottomProps> = ({
    message,
    rows,
    className,
    testID,
}) => (
    <Box testID={testID} className={twMerge('w-full gap-2 bg-graphics-yellow p-6', className)}>
        <Text size='body' weight='medium' tone='on-graphics'>
            {message}
        </Text>
        {rows.map((row, index) => (
            <HStack key={index} className='items-center gap-3'>
                <Text size='body' weight='medium' tone='on-graphics'>
                    {row.label}
                </Text>
                <Text size='heading' weight='medium' tone='on-graphics'>
                    {row.value}
                </Text>
            </HStack>
        ))}
    </Box>
)
MessageBottom.displayName = 'MessageBottom'
